import { useEffect, useRef } from 'react';

interface IWrapperProps<T> extends React.HTMLAttributes<HTMLDivElement> {
	svgElement: T;
}

export function Wrapper<T extends SVGSVGElement | HTMLElement>({
	svgElement,
	...props
}: IWrapperProps<T>) {
	const svg = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (svg.current && svgElement) {
			svg.current.appendChild(svgElement);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <div ref={svg} {...props} />;
}
